module.exports = "/_next/static/images/alpha-dc3bcf4559f586086187bbc5b4fbdd9d.svg";